import { render, staticRenderFns } from "./CartaoData.vue?vue&type=template&id=ee87462a&scoped=true"
import script from "./CartaoData.vue?vue&type=script&lang=js"
export * from "./CartaoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee87462a",
  null
  
)

export default component.exports